export default __webpack_public_path__ + "static/media/mars-onboarding-2.657d06e7.svg";